var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 26,
    width: 31,
    height: 3,
    rx: 1.5,
    fill: "#6ABEA5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.9395L24 13.9395V20.25C24 20.8467 23.7629 21.419 23.341 21.841C22.919 22.2629 22.3467 22.5 21.75 22.5H8.25C7.65326 22.5 7.08097 22.2629 6.65901 21.841C6.23705 21.419 6 20.8467 6 20.25V13.9395L15 4.9395ZM22.5 3.75V9L19.5 6V3.75C19.5 3.55109 19.579 3.36032 19.7197 3.21967C19.8603 3.07902 20.0511 3 20.25 3H21.75C21.9489 3 22.1397 3.07902 22.2803 3.21967C22.421 3.36032 22.5 3.55109 22.5 3.75Z",
    fill: "#6ABEA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9404 2.24973C14.2217 1.96852 14.6032 1.81055 15.0009 1.81055C15.3987 1.81055 15.7802 1.96852 16.0614 2.24973L26.0319 12.2187C26.1728 12.3596 26.2519 12.5506 26.2519 12.7497C26.2519 12.9489 26.1728 13.1399 26.0319 13.2807C25.8911 13.4216 25.7001 13.5007 25.5009 13.5007C25.3018 13.5007 25.1108 13.4216 24.9699 13.2807L15.0009 3.31023L5.03195 13.2807C4.89112 13.4216 4.70011 13.5007 4.50095 13.5007C4.30178 13.5007 4.11078 13.4216 3.96995 13.2807C3.82912 13.1399 3.75 12.9489 3.75 12.7497C3.75 12.5506 3.82912 12.3596 3.96995 12.2187L13.9404 2.24973Z",
    fill: "#6ABEA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlat);
export default __webpack_public_path__ + "static/media/flat.db6e720fac473e65e8ccdf80d7630e9b.svg";
export { ForwardRef as ReactComponent };